export default "__VITE_ASSET__BUKKnBu3__"